const searchQuery = document.querySelector('[data-search-query]');
const searchResults = document.querySelector('[data-search-results-clerk]');
const filterLoadMoreBtn = document.querySelector('[data-load-more]');
const filterSearchCountElement = document.querySelector('[data-search-count]');

function clerkFetchOption(filter) {
  loadMoreBtn.setAttribute('data-active-filter', filter)
  Clerk('call', 'search/search', {
    key: theme.strings.clerkApiKey,
    labels: ['CLERK - Search Page - Filtered Results'],
    query: searchQuery.dataset.searchQuery,
    filter: `tags contains not "exclude_clerk" and ${filter}`,
    attributes: ['handle'],
    limit: 42,
  },
    async function (response) {
      const productItem = await Promise.all(response.product_data
        .map(item => fetch(`/products/${item.handle}?view=item`)
          .then(response => {
            if (response.status >= 200 && response.status < 300) {
              return response.text();
            }

            throw new Error(
              `Could not fetch linked products. Server responded with: ${response.status}`
            );
          })
          .catch(error => {
            console.log(error)
            return ''
          })
        )
      );

      if (response.hits > 42) {
        filterLoadMoreBtn.classList.remove('hide');
      } else {
        filterLoadMoreBtn.classList.add('hide');
      }

      filterSearchCountElement.innerHTML = theme.strings.searchTitle.replace('--count--', response.hits);

      window.Clerk('click', '*[data-clerk-product-id]');
      searchResults.innerHTML = productItem.join('');
    }
  )
}

const filterWrappers = document.querySelectorAll('[data-filter-wrapper]');
filterWrappers.forEach(filterWrapper => {
  const filterInputs = filterWrapper.querySelectorAll('input');

  function updateFilter(price = null) {
    const filterOptions = filterWrapper.querySelectorAll('[data-filter-option]');
    const filterArray = [];
    filterOptions.forEach(filterOption => {
      const checkedInputs = filterOption.querySelectorAll('input:checked');
      const values = Array.from(checkedInputs).map(i => i.value);
      const filterType = filterOption.dataset.filterOption;
      if (filterType !== 'price') {
        let filter = [];
        values.forEach(value => {
          filter.push(`${filterType} = "${value}"`);
        });
        if (filter.length) {
          filterArray.push(`(${filter.join(' or ')})`)
        }
      }
    });

    if (price) {
      filterArray.push(`price >= ${price[0]} and price <= ${price[1]}`);
    }

    const filterString = filterArray.join(' and ');
    clerkFetchOption(filterString);
  }

  if (filterInputs.length) {
    filterInputs.forEach(filterOption => {
      filterOption.addEventListener('change', () => {
        updateFilter();
      });
    });
  }

  const priceSliderSelect = filterWrapper.querySelector('.price-range');
  new theme.PriceRange(priceSliderSelect, {
    onChange: (formData) => {
      var prices = [];
      formData.forEach((value) => prices.push(parseInt(value)));
      updateFilter(prices)
    }
  })
});